// src/index.ts
import createClient from "openapi-fetch";

// src/schema/schema.ts
var schema_exports = {};

// src/index.ts
var src_default = (baseUrl, headers) => {
  return createClient({
    baseUrl,
    headers
  });
};
export {
  schema_exports as KoiosTypes,
  src_default as default
};
